export const PriorityData = [
  { label: 'Retardé', value: 0 },
  { label: 'Tranquille', value: 1 },
  { label: 'Normal', value: 2 },
  { label: 'Pressé', value: 3 },
  { label: 'Urgent', value: 4 }
]
